import { LabradorComponentsPreview } from '@/components/labrador/preview';
import { ComponentsPreview } from '@/components/preview';
import { Tabs } from '@/components/Tabs';
import type { GetServerSideProps, NextPage } from 'next';
import { useParams } from 'next/navigation';
import { useState } from 'react';

const NoPreview = () => <div className="text-center">Preview not available</div>;

const tabs = ['Standalone', 'Labrador'];

export const ComponentPreview = ({ component }: { component: string }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const StandalonePreview = ComponentsPreview[component as keyof typeof ComponentsPreview] || NoPreview;
  const LabradorPreview = LabradorComponentsPreview[component as keyof typeof LabradorComponentsPreview] || NoPreview;

  return (
    <>
      <div className="m-3 text-center">
        <Tabs
          tabs={tabs.map((tab) => ({
            content: tab,
            href: '#',
            isActive: tab === activeTab,
            onClick: (ev: any) => {
              ev.preventDefault();
              setActiveTab(tab);
            },
          }))}
        />
      </div>

      {activeTab === 'Standalone' && <StandalonePreview />}
      {activeTab === 'Labrador' && <LabradorPreview />}
    </>
  );
};

const ComponentPreviewPage: NextPage = () => {
  const { component } = useParams();

  return (
    <section className="mx-auto max-w-grid p-grid-m">
      <ComponentPreview component={component as string} />
    </section>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  return { props: {} };
};

export default ComponentPreviewPage;
